import React from 'react'

function NotFound() {
  return (
    <div>
      hi
    </div>
  )
}

export default NotFound
